import ELookupAPIKeys from 'types/backend_models/lookup_status/ELookupAPIKeys'
import { TRootState } from 'redux/reducers/rootReducer'
import RequestStatus from 'types/general/requests/RequestStatus'
import { useThunkDispatch } from './useThunkDispatch'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { ILookupStateModel } from 'redux/reducers/data_action_reducers/lookup_status/lookupDataReducer'
import { fetchLookup } from '../redux/actions/dataActions/lookup_status/lookupDataActions';

function useLookupDynamic(lookupAPIKey: ELookupAPIKeys): ILookupStateModel
{
    const thunkDispatch = useThunkDispatch();

    const lookupState = useSelector((state: TRootState) => state.data.lookups[lookupAPIKey]);

    useEffect(() =>
    {
        if (lookupState.requestStatus === RequestStatus.idle) {
            console.log('lookupDataFetch, key:', lookupAPIKey.toString());
            thunkDispatch(fetchLookup(lookupAPIKey));
        }
    }, [thunkDispatch, lookupAPIKey, lookupState]);

    return lookupState;
}

export default useLookupDynamic;